import "./ErrorPage.css"

import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"

import Button from "@/components/Button/Button"

export default function ErrorPage() {
  const { t } = useTranslation()
  return (
    <div className="unauth__page">
      <div className="mb-5 d-flex flex-column gap-4">
        <h1 className="fw-bolder mb-0">{t("errorPage.title")}</h1>
        <h4 className="mb-0">{t("errorPage.subtitle")}</h4>
        <div className="d-flex flex-column justify-content-center flex-lg-row gap-lg-2">
          <div>
            <Button>
              <Link to="/" className="text-white text-decoration-none">
                {t("errorPage.buttons.home")}
              </Link>
            </Button>
          </div>
        </div>
      </div>
      <div className="error__img">
        <img src="/assets/images/errorPage.svg" alt="" />
      </div>
    </div>
  )
}
